module.exports = __webpack_public_path__ + "static/media/16@1024w.42300821.jpg";